import { useFragment, graphql } from 'react-relay';
import { getPriceFromAmountListByCurrency } from 'dibs-buyer-price/exports/getPriceFromAmountListByCurrency';
import { isPriceAboveLimit } from './helpers';

import { useShowPricingGuidance_item$key } from './__generated__/useShowPricingGuidance_item.graphql';

const itemFragment = graphql`
    fragment useShowPricingGuidance_item on Item {
        pricingGuidance(
            isTrade: $isTrade
            buyerId: $userId
            userCountryCode: $userCountryCode
            priceBookName: $priceBookName
        ) {
            medianAmount {
                convertedAmountList {
                    amount
                    currency
                }
            }
        }
        displayPrice(
            isTrade: $isTrade
            buyerId: $userId
            userCountryCode: $userCountryCode
            priceBookName: $priceBookName
        ) {
            convertedAmountList {
                # eslint-disable-next-line relay/unused-fields
                amount
                currency
            }
        }
    }
`;

export const useShowPricingGuidance = ({
    item: itemRef,
    currency,
}: {
    item?: useShowPricingGuidance_item$key | null;
    currency: string;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const { pricingGuidance, displayPrice = null } = item || {};

    if (!pricingGuidance) {
        return false;
    }

    const price = getPriceFromAmountListByCurrency(
        displayPrice?.[0]?.convertedAmountList || null,
        currency
    );

    if (!price) {
        return false;
    }

    const median = getPriceFromAmountListByCurrency(
        pricingGuidance.medianAmount?.convertedAmountList || null,
        currency
    );

    if (isPriceAboveLimit({ price, median, currency })) {
        return false;
    }

    return true;
};
